
const boardData = {

	title: "Our Board",
	board: [
		{
			image: {
				src: "/assets/images/team/mpho.jpg",
				alt: "Mpho Letlape",
			},
			name: "Mpho Letlape",
			title: "Chair of the board",
		},
		{
			image: {
				src: "/assets/images/team/sarah_rennie.jpg",
				alt: "Sarah Rennie",
			},
			name: "Sarah Rennie",
			title: "Director",
		},
		{
			image: {
				src: "/assets/images/team/zimkita_mabindla.jpg",
				alt: "Zimkita Mabindla",
			},
			name: "Zimkita Mabindla",
			title: "Director",
		},
		{
			image: {
				src: "/assets/images/team/keshni_kuni.jpg",
				alt: "Keshni Kuni ",
			},
			name: "Keshni Kuni",
			title: "Director",
		},
		{
			image: {
				src: "/assets/images/team/Dr_Fulufhelo.jpg",
				alt: "Dr Fulufhelo Nelwamondo",
			},
			name: "Dr Fulufhelo Nelwamondo",
			title: "Director",
		},
	],

}

export { boardData };
